import { Box, chakra, Flex, Image, shouldForwardProp } from "@chakra-ui/react";
import { isValidMotionProp, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import useWebsiteInfo from "../../hook/useWebsiteInfo";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const WebsiteMaintainWrapper = ({ children }) => {
  const { t } = useTranslation();
  const i18n_common = (key, props) => t(`common.${key}`, { ...props });

  const { images } = useWebsiteInfo();

  const isMaintain = window.is_under_maintenance;
  return isMaintain ? (
    <Box
      w="100%"
      h="100dvh"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
    >
      <ChakraBox
        as={Flex}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.3 }}
        w="520px"
        minH="300px"
        bgImage={`url('${images.hintBG}')`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100% 100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
        position={"relative"}
        p={6}
      >
        <Flex
          fontSize="24px"
          color="white"
          textAlign="center"
          mt={4}
          bgImage={`url('${images.hintTitleBG}')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          sx={{ width: "-webkit-fill-available" }}
          justifyContent="center"
          alignItems="center"
        >
          <Image
            src={images.hintWORD}
            height={{
              base: "50px",
              xl: "60px",
            }}
          />
        </Flex>

        <Box fontSize="24px" color="white" textAlign="center" mb={2}>
          {i18n_common("站台維護中")}
        </Box>

        <Flex
          gap={4}
          mb={4}
          justifyContent="space-between"
          alignItems="center"
        ></Flex>
      </ChakraBox>
    </Box>
  ) : (
    children
  );
};

export default WebsiteMaintainWrapper;
